(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    

    $(document).ready(function ()
    {
    NL.blog.init();
    })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index_hero_slider"] && !Shopify.designMode) return;
  try {
    



    $(document).ready(function ()
    {
    NL.hero.init();
    })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"]) return;
  try {
    
$(document).ready(function ()
{
NL.pdp.init();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
    $(document).ready(function ()
    {
    NL.pdp.init();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_bak_mzp_20230623_140353"]) return;
  try {
    
    $(document).ready(function ()
    {
    NL.pdp.init();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-template-bc-sf-filter"]) return;
  try {
    



$(document).ready(function ()
{
    NL.collection.init();
})




  } catch(e) { console.error(e); }
})();
})();
